import React from 'react';

const GreenCheckmark = ({ className = 'h-4 w-4 sm:h-5 sm:w-5' }) => {
  return (
    <svg
      className={`fill-[#00b42c] ${className}`}
      clipRule='evenodd'
      fillRule='evenodd'
      imageRendering='optimizeQuality'
      shapeRendering='geometricPrecision'
      textRendering='geometricPrecision'
      viewBox='0 0 43.3492 43.3492'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Layer_x0020_1'>
        <g id='_553428304'>
          <path
            id='_553427992'
            d='m19.2886 31.335c-.2115 0-.3878-.141-.4583-.3173-.0352-.0705-3.0674-7.8976-7.7566-10.8592-.9167-.5641-1.6217-1.1635-1.3397-2.5033.282-1.3045 1.1635-2.0449 2.75-2.3975 2.8205-.5994 5.8526 3.7725 6.9809 5.5707 3.9487-5.7469 11.8463-14.7728 23.3401-15.8305.5545-.065.7595.7569.2468.9872-.1763.0705-16.6062 7.5804-23.2697 25.0679-.1057.1762-.282.282-.4935.282z'
          />
        </g>
      </g>
    </svg>
  );
};

export default GreenCheckmark;
